import { requireAuth } from '@/router/helpers';

export default [
  // USERS
  // -----------------------------------------------------------

  // Test Screen (Development Only)
  {
    path: '/test-screen',
    name: 'TestScreen',
    component: () => import('@/views/admin/TestScreen'),
    beforeEnter: requireAuth,
    meta: {
      isAdmin: true,
    },
  },

  {
    path: '/admin/dashboard',
    name: 'DashboardAdmin',
    component: () => import('@/views/admin/Dashboard/index'),
    beforeEnter: requireAuth,
    meta: {
      isAdmin: true
    }
  },

  {
    path: '/admin/dashboard/edit',
    name: 'DashboardAdminEdit',
    component: () => import('@/views/admin/Dashboard/edit'),
    beforeEnter: requireAuth,
    meta: {
      isAdmin: true
    }
  }
];
